// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3i1LI","footer":"ModalError_footer__1rXKX"};